// Human labels for the closed TeamAccessAction vocabulary (backend/src/lib/
// subscription-audit.ts) and the team.* actions written directly in
// backend/src/routes/admin/teams/index.ts. Falls back to the raw action
// string for anything not listed here, so a new action never disappears —
// it just shows up unlabeled until someone adds it.
const ACTION_LABELS: Record<string, string> = {
  "team_subscription.attach": "Plan attached",
  "team_subscription.comped": "Plan comped",
  "team_subscription.comp_revoked": "Comp revoked",
  "team_subscription.trial_created": "Trial started",
  "team_subscription.trial_date_changed": "Trial date changed",
  "team_subscription.checkout_completed": "Checkout completed",
  "team_subscription.orphan_activated": "Pending subscription activated",
  "team_subscription.orphan_trial_cancelled": "Orphan trial cancelled",
  "team_subscription.updated": "Plan updated",
  "team_subscription.revoked": "Access revoked",
  "team.member_import": "Members imported",
  "team.member_invite": "Member invited",
  "team.member_add": "Member added",
  "team_invitation.resend": "Invitation resent",
  "team_invitation.resend_all": "All invitations resent",
}

export function actionLabel(action: string): string {
  return ACTION_LABELS[action] ?? action
}
